import Icon from '../components/Icon.vue'

Icon.register({
  'external-link-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 24v128c0 21.5-26 32-41 17l-35.7-35.7-243.5 243.5c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l243.5-243.5-35.7-35.7c-15.1-15.1-4.4-41 17-41h128c13.3 0 24 10.7 24 24zM407 270.8c15.1-15.1 41-4.4 41 17v176.2c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h296c21.4 0 32.1 25.9 17 41l-16 16c-3.9 3.9-11.5 7-17 7h-264v320h320v-144.2 0c0-5.5 3.1-13.1 7-17z'
      }
    ]
  }
})
